export enum OriginatorPublicActions {
    GET_PUBLIC_ORIGINATOR = "getPublicOriginator"
}
export enum OriginatorPublicMutations {
    SET_PUBLIC_ORIGINATOR = "setOriginatorUser"
}
